import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'over55.singles',
  TITLE: 'Over 55 Singles',
  NICHE: 'over55',
  PROJECT: 'over55',
  NICHE_SINGULAR: 'over55',
  NICHE_PLURAL: 'over55',
  FB_TRACKING_PIXEL_ID: ['889380741423256', '274845220963926'],
  VERIZON_TRACKING_PIXEL: '10111266',
  TABOOLA_TRACKING_PIXEL: '1800925',
  TIKTOK_PIXEL: 'CEBNIJBC77UD28TR0C30',
  TYPE: 'mainstream',
  AGE_SLIDER_LOWER: 55,
  AGE_SLIDER_UPPER: 99,
  SENTRY_RELEASE: 'www-over55-singles',
  SENTRY_DNS: 'https://9ad519bc8f660739b2207ef007c3673b@sentry.nearbyapi.com/9',
  VWO_ID: 302021,
  BING_TRACKING_PIXEL: ['343181377'],
});

export default config;
